import { render, staticRenderFns } from "./VisualizarAgendamento.vue?vue&type=template&id=2498ff4d&"
import script from "./VisualizarAgendamento.vue?vue&type=script&lang=js&"
export * from "./VisualizarAgendamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports